import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { GlobalTax } from '../../../models/global-tax';

import { GlobalTaxService } from '../../../services/accounting/global-tax.service';
import { UserService } from '../../../services/users/user.service';

@Component({
  selector: 'app-global-tax-index',
  templateUrl: './global-tax-index.component.html',
  styleUrls: ['./global-tax-index.component.scss'],
})
export class GlobalTaxIndexComponent implements OnInit {
  count: number = 0;

  globalTaxes: Array<GlobalTax> = [];

  loading: boolean = true;

  constructor(private globalTaxService: GlobalTaxService, private router: Router, private userService: UserService) {}

  ngOnInit() {
    this.userService.navbarComponent.setTaxesMenu();
    this.loadGlobalTaxes();
  }

  loadGlobalTaxes() {
    this.loading = true;
    this.globalTaxService
      .index()
      .then((response_json) => {
        this.loading = false;
        this.count = response_json.count;
        this.globalTaxes = response_json.global_taxes;
      })
      .catch(() => {
        this.loading = false;
      });
  }

  openNewGlobalTax() {
    this.router.navigateByUrl('/global_taxes/new');
  }
}
